import {
  EmailActionUnreadLight,
  Hyperlink3Light,
  MessagesBubbleTyping1Light,
  ProfessionalNetworkLinkedInLight,
  SocialMediaFacebookLight,
} from '@ha/icons';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { makeStyles } from '@material-ui/core';
import { useLocation } from 'react-router-dom';

import { useIntl } from 'ha/i18n';
import { ShareToSocialNetworks } from 'ha/components.legacy/ShareToSocialNetworks';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';

import { Grid, IconButton } from '@ha/dsl';

const useStyles = makeStyles({
  icon: {
    backgroundColor: 'white',
    boxShadow: '0 20px 40px 0 rgba(45, 70, 88, 0.08)',
    marginBottom: '0.5rem',
    marginRight: '0.5rem',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
});

export interface DispatchProps {
  initFB: () => void;
}

interface OwnProps {
  title: string;
  wrapperClassname: string;
  isMobile?: boolean;
}

export const ShareButtons: React.FC<OwnProps & DispatchProps> = ({
  title,
  wrapperClassname,
  isMobile,
  initFB,
}) => {
  React.useEffect(() => {
    initFB();
  }, []);

  const { urlResolver } = useIntl();
  const classes = useStyles();
  const location = useLocation();

  return (
    <ShareToSocialNetworks location={location} shareMessage={title}>
      {({ shareUrls, handleFbMessengerClick }) => (
        <Grid
          container
          item
          justify={isMobile ? 'center' : undefined}
          direction={isMobile ? 'row' : 'column'}
          className={wrapperClassname}
        >
          <Track name="Clicked a share button" type="facebook">
            <IconButton
              target="_blank"
              rel="noopener noreferer nofollow"
              href={shareUrls.facebook}
              classes={{ root: classes.icon }}
            >
              <SocialMediaFacebookLight data-test-locator="Share Facebook" />
            </IconButton>
          </Track>
          <Track name="Clicked a share button" type="linkedin">
            <IconButton
              classes={{ root: classes.icon }}
              href={shareUrls.linkedin}
              target="_blank"
              rel="noopener noreferer nofollow"
            >
              <ProfessionalNetworkLinkedInLight data-test-locator="Share linkedin" />
            </IconButton>
          </Track>
          <Track name="Clicked a share button" type="messenger">
            <IconButton
              classes={{ root: classes.icon }}
              {...(isMobile
                ? {
                    href: shareUrls.messenger,
                    target: '_self',
                    rel: 'noopener noreferer nofollow',
                  }
                : { onClick: handleFbMessengerClick })}
            >
              <MessagesBubbleTyping1Light data-test-locator="Share messenger" />
            </IconButton>
          </Track>
          <Track name="Clicked a share button" type="email">
            <IconButton
              href={shareUrls.email}
              target="_self"
              rel="noopener noreferer nofollow"
              classes={{ root: classes.icon }}
            >
              <EmailActionUnreadLight data-test-locator="Share to email" />
            </IconButton>
          </Track>
          <Track name="Clicked a copy" type="copy">
            <CopyToClipboard
              text={urlResolver.absolutizePath(location.pathname, {
                skipAddLanguage: true,
              })}
            >
              <IconButton classes={{ root: classes.icon }}>
                <Hyperlink3Light data-test-locator="Copy To Clipboard" />
              </IconButton>
            </CopyToClipboard>
          </Track>
        </Grid>
      )}
    </ShareToSocialNetworks>
  );
};
